export const ageDecadeFormatter = (age: number): string => {
  return `${age.toString().slice(0, 1)}0代`
}
